const OffsetToNegativeXPosition = {
  [-3600]: 814,
  [-7200]: 792,
  [-10800]: 770,
  [-14400]: 748,
  [-18000]: 726,
  [-21600]: 704,
  [-25200]: 682,
  0: 660,
  [-86400]: 638,
  [-172800]: 616,
  [-259200]: 594,
  [-345600]: 572,
  [-432000]: 550,
  [-518400]: 528,
  [-604800]: 506,
  [-691200]: 484,
  [-777600]: 462,
  [-864000]: 440,
  [-950400]: 418,
  [-1036800]: 396,
  [-1123200]: 374,
  [-1209600]: 352,
  [-1296000]: 330,
  [-1382400]: 308,
  [-1468800]: 286,
  [-1555200]: 264,
  [-1641600]: 242,
  [-1728000]: 220,
  [-1814400]: 198,
  [-1900800]: 176,
  [-1987200]: 154,
  [-2073600]: 132,
  [-2160000]: 110,
  [-2246400]: 88,
  [-2332800]: 66,
  [-2419200]: 44,
  [-2505600]: 22,
  [-2592000]: 0,
}

export default OffsetToNegativeXPosition



// WEBPACK FOOTER //
// ./src/components/sitewide/OffsetToNegativeXPosition.js